import { render, staticRenderFns } from "./shopComponent.vue?vue&type=template&id=62fca2c0&"
import script from "./shopComponent.vue?vue&type=script&lang=js&"
export * from "./shopComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports